export const fwoStatusList = [
  {
    value: 'pending',
    label: 'Pending',
  },
  {
    value: 'approved',
    label: 'Approved',
  },
  {
    value: 'denied',
    label: 'Denied',
  },
];



// WEBPACK FOOTER //
// ./src/services/utils/field-work-order-util.js